import { render, staticRenderFns } from "./tenderInfoContent.vue?vue&type=template&id=fae362f0&scoped=true&"
import script from "./tenderInfoContent.vue?vue&type=script&lang=js&"
export * from "./tenderInfoContent.vue?vue&type=script&lang=js&"
import style0 from "./tenderInfoContent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tenderInfoContent.vue?vue&type=style&index=1&id=fae362f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae362f0",
  null
  
)

export default component.exports